export const menuStyle = {
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    right: '20px',
    top: '30px',
    boxShadow: '0px 0px 10px 10px white',
    borderRadius: '50%',
    backgroundColor: 'white',
  },

  bmBurgerBars: {
    background: '#373a47',
  },

  bmBurgerBarsHover: {
    background: '#a90000',
  },

  bmCrossButton: {
    height: '24px',
    width: '24px',
  },

  bmCross: {
    background: '#bdc3c7',
  },

  bmMenuWrap: {
    position: 'fixed',
    height: '100%',
  },

  bmMenu: {
    background: 'rgb(34, 64, 39)',
    padding: '2.5em 1.5em 0',
    fontSize: '1em',
    boxShadow: '5px 8px 10px 10px black',
    textAlign: 'left'
  },

  bmMorphShape: {
    fill: '#373a47',
  },

  bmItemList: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0.8em',
    textAlign: 'left'
  },

  bmItem: {
    display: 'inline-block',
    textDecoration: 'none',
    color: '#888682',
    margin: '10px',
    fontSize: '1.2rem',
    textAlign: 'left'
  },

  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.3)',
  },
};
